/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PutOrgAutoModelRequest = {
  /**
   * The model id this org's `"auto"` should resolve to for this endpoint. Cannot be the literal string "auto".
   */
  modelId: string;
};

/** @internal */
export const PutOrgAutoModelRequest$inboundSchema: z.ZodType<
  PutOrgAutoModelRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  modelId: z.string(),
});
/** @internal */
export type PutOrgAutoModelRequest$Outbound = {
  modelId: string;
};

/** @internal */
export const PutOrgAutoModelRequest$outboundSchema: z.ZodType<
  PutOrgAutoModelRequest$Outbound,
  z.ZodTypeDef,
  PutOrgAutoModelRequest
> = z.object({
  modelId: z.string(),
});

export function putOrgAutoModelRequestToJSON(
  putOrgAutoModelRequest: PutOrgAutoModelRequest,
): string {
  return JSON.stringify(
    PutOrgAutoModelRequest$outboundSchema.parse(putOrgAutoModelRequest),
  );
}
export function putOrgAutoModelRequestFromJSON(
  jsonString: string,
): SafeParseResult<PutOrgAutoModelRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PutOrgAutoModelRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PutOrgAutoModelRequest' from JSON`,
  );
}
